import { useEffect, useState } from 'react'
import Table from "react-table-lite";
import "../assets/css/Grid.css";

export default function GridControl(props) {	
	const [currentPage, _currentPage] = useState(1);
	const [sumCurrentPage, _sumCurrentPage] = useState(0);
	let recordCount = 10;
	
	let CustomRenderCellElement = {
		ViewAction: (row) => (
			<div role="button" onClick={()=>props.ViewAction(row)}> 
				<i class="fa fa-eye"></i>
			</div>
		),
		ViewFish: (row) => (
			(row.IsDisplayable == true ?  
				<div role="button" onClick={()=>props.ViewFish(row)}> 
					<i class="fa fa-eye"></i>
				</div>
			:
				<div>-</div>
			)
		),		
		OpenFile: (row) => (
			<div role="button" onClick={()=>props.OpenFile(row)}> 
				<i class="fa fa-folder-open"></i>
			</div>
		),		
		EditAction: (row) => (
			(row.IsEditable == true ?  
				<div role="button" onClick={()=>props.EditAction(row)}> 
					<i class="fa fa-edit"></i>
				</div>
			:
				<div>-</div>
			)			
		),	
		DeleteAction: (row) => (
			<div role="button" onClick={()=>props.DeleteAction(row)}> 
				<i class="fa fa-remove text-danger"></i>
			</div>
		),	
		PaymentAction: (row) => (
			(row.IsPayable == true ?  
				<div role="button" onClick={()=>props.PaymentAction(row)}> 
					<i class="fa fa-credit-card"></i>
				</div>
			:
				<div>-</div>
			)
		),	
		PrintAction: (row) => (
			<div role="button" onClick={()=>props.PrintAction(row)}> 
				<i class="fa fa-print"></i> 
			</div> 
		),	
		DownloadAction: (row) => (
			<div role="button" onClick={()=>props.DownloadAction(row)}> 
				<i class="fa fa-download"></i> 
			</div> 
		),	
		
		Amount: (row) => (
			row.Amount && row.Amount.toLocaleString()
		),			
		
		PayableAmount: (row) => (
			row.PayableAmount && row.PayableAmount.toLocaleString()
		),	
			
		
		ComboBox: (row) => (
			props.ComboBox(row)
		),
		ConfirmAction: (row) => (
			<div className="btn btn-success" style={{width:'80px'}} onClick={()=>props.ConfirmAction(row)}> 
				تایید
			</div> 
		),
		RejectAction: (row) => (
			<div className="btn btn-danger" style={{width:'80px'}} onClick={()=>props.RejectAction(row)}> 
				عدم تایید
			</div> 
		),	
		SelectEditAction: (row) => (
			<div className="btn btn-warning" style={{lineHeight:'10px'}} onClick={()=>props.SelectEditAction(row)}> 
				<i class="fa fa-edit"></i>
			</div> 
		)
	};
	
	return (
		<div className="responseTable">
			<Table
				data={props.data && props.data.slice(sumCurrentPage, sumCurrentPage+recordCount)}
				headers={Object.keys(props.customHeaders)}
				customHeaders={props.customHeaders}
				searchable={false}
				//showPagination={props.data.length > recordCount && props.showPagination ? true: false}
				showPagination={props.data.length > recordCount}	
				headerStyle = {{textAlign:'center'}}
				cellStyle  = {{textAlign:'center'}}		
				tableClass="table table-striped bordered"		
				headerClass="border"
				cellClass="border"	
				showActions = {props.showActions}        
				actionTypes={props.actionTypes}	
				onRowView={props.onRowView}	
				noDataMessage = {"داده ای برای نمایش وجود ندارد"}
				customRenderActions={props.customRenderActions}  
				customRenderCell={Object.assign(CustomRenderCellElement, props.customRenderCell)}		
				totalPages={Math.ceil((props.data.length)/recordCount)}  	
				showNumberofPages={5}
				currentPage={currentPage}
				onPaginate={(event, pageNo)=>{
					_currentPage(pageNo);
					if(pageNo == 1)
						_sumCurrentPage(0);
					else
						_sumCurrentPage(pageNo*recordCount-recordCount);
				}}				
			/>
		</div>
	)
}